<div class="scan-cont" [hidden]="!hasPermission">
	<h4 class="header-title">{{ locale.translations['ads']['qrcode']['n410'] }}</h4>
	<!-- <zxing-scanner
		[torch]="torchEnabled"
		[(device)]="currentDevice"
		(scanSuccess)="onCodeResult($event)"
		[formats]="formatsEnabled"
		[tryHarder]="tryHarder"
		(permissionResponse)="onHasPermission($event)"
		(camerasFound)="onCamerasFound($event)"
		(torchCompatible)="onTorchCompatible($event)"
	></zxing-scanner> -->
</div>

<ng-container *ngIf="hasPermission === false">
	<div class="mx-auto text-center img-margin">
		<img class="text-center" [src]="'assets/images/camera-permission.gif' | s3Image" alt="" />

		<h2 class="permission-head">{{ locale.translations['ads']['qrcode']['n428'] }}</h2>

		<p class="permission-text">
			{{ locale.translations['ads']['qrcode']['n429'] }}
			<br />
			{{ locale.translations['ads']['qrcode']['n414'] }}
		</p>

		<div class="btn-cont">
			<button type="button" mat-flat-button (click)="location.back()" class="btn-light m-1 go-back-btn btn-default">
				{{ locale.translations['ads']['qrcode']['n430'] }}
			</button>

			<button type="button" mat-flat-button color="primary" type="submit" [routerLink]="['/c/15']" class="m-1 go-home-btn btn-default">
				{{ locale.translations['ads']['qrcode']['n431'] }}
			</button>
		</div>
	</div>
</ng-container>
